exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1qMM0ddxBI9niS8nlhn5jN{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;font-size:14px;font-weight:400}._3DdNtPGQrSGZ-Wif8WLalV{max-width:470px;width:470px;font-size:21px;font-weight:100}._21mqjbviDL3MTi4KaG-Dz1{min-width:350px}", ""]);
// Exports
exports.locals = {
	"folderPermissionsBody": "_1qMM0ddxBI9niS8nlhn5jN",
	"folderPermissionsContainer": "_3DdNtPGQrSGZ-Wif8WLalV",
	"folderPermissionUpdateErrorDialog": "_21mqjbviDL3MTi4KaG-Dz1"
};